import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import './ProfileVisibilityInfo.scss';

const ProfileVisibilityInfo: React.FC = () => {
  const tooltipContent = (
    <div className="visibility-tooltip-content">
      <div className="visibility-scenario">
        <strong>“Hide my profile” checked</strong>
        <br />
        <strong>”Is for brand deals only” unchecked</strong>
        <div className="result">→ Not shown on platform, not shown on CB</div>
      </div>
      <div className="visibility-scenario">
        <strong>“Hide my profile” checked</strong>
        <br />
        <strong>”Is for brand deals only” checked</strong>
        <div className="result">→ Not shown on platform, shown on CB</div>
      </div>
      <div className="visibility-scenario">
        <strong>“Hide my profile” unchecked</strong>
        <br />
        <strong>”Is for brand deals only” unchecked</strong>
        <div className="result">→ Shown on platform, shown on CB</div>
      </div>
    </div>
  );

  return (
    <span className="profile-visibility-info">
      <Tooltip
        title={tooltipContent}
        placement="right"
        overlayClassName="profile-visibility-tooltip-overlay"
      >
        <InfoCircleOutlined className="info-icon" />
      </Tooltip>
    </span>
  );
};

export default ProfileVisibilityInfo;
